import { render, staticRenderFns } from "./HomeFollowedTopics.vue?vue&type=template&id=787d19fa&scoped=true"
import script from "./HomeFollowedTopics.vue?vue&type=script&lang=js"
export * from "./HomeFollowedTopics.vue?vue&type=script&lang=js"
import style0 from "./HomeFollowedTopics.vue?vue&type=style&index=0&id=787d19fa&prod&scoped=true&lang=css"
import style1 from "./HomeFollowedTopics.vue?vue&type=style&index=1&id=787d19fa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "787d19fa",
  null
  
)

export default component.exports